import { createActionNameForProcessingFetch } from '../../utils/helpers/actionCreatorHelpers';

import { JOB_APPLICATIONS_DOMAIN_NAME } from './constants';

export const getJobApplicationsConstants = createActionNameForProcessingFetch('getJobApplications', JOB_APPLICATIONS_DOMAIN_NAME);

export const updateJobApplicationConstants = createActionNameForProcessingFetch('updateJobApplication', JOB_APPLICATIONS_DOMAIN_NAME);

// eslint-disable-next-line import/prefer-default-export
export const cancelRejectionEmailConstants = createActionNameForProcessingFetch('cancelRejectionEmail', JOB_APPLICATIONS_DOMAIN_NAME);

export const createJobApplicationAdminConstants = createActionNameForProcessingFetch('createJobApplicationAdmin', JOB_APPLICATIONS_DOMAIN_NAME);

export const deleteJobApplicationConstants = createActionNameForProcessingFetch('deleteJobApplication', JOB_APPLICATIONS_DOMAIN_NAME);

export const sendInterviewInviteConstants = createActionNameForProcessingFetch('sendInterviewInvite', JOB_APPLICATIONS_DOMAIN_NAME);
